/**
 * Subscriber % discount applies only when the catalog row is explicitly DT One (provider_id 1).
 * A2P (2), G2G (3), and any other / missing provider_id — no discount.
 */

export function resolveProductProviderIdForDiscount(product, cartItem = null) {
  // Prefer cart-line provider_id (set from API / normalize) over possibly stale product.provider_id
  const fromItem = cartItem?.provider_id;
  if (fromItem != null && Number.isFinite(Number(fromItem))) return Number(fromItem);
  const fromProduct = product?.provider_id;
  if (fromProduct != null && Number.isFinite(Number(fromProduct))) return Number(fromProduct);
  return null;
}

export function productEligibleForSubscriberDiscount(product, cartItem = null) {
  return resolveProductProviderIdForDiscount(product, cartItem) === 1;
}

export function cartLineEligibleForSubscriberDiscount(item) {
  return productEligibleForSubscriberDiscount(item?.product, item);
}

/** Sum of (price × qty) for lines that qualify for subscriber discount */
export function subscriberDiscountEligibleSubtotal(cartItems) {
  if (!Array.isArray(cartItems)) return 0;
  return cartItems.reduce((sum, item) => {
    if (!cartLineEligibleForSubscriberDiscount(item)) return sum;
    const product = item.product || {};
    const price = Number(item.amount ?? product.prices?.retail?.amount ?? 0);
    const qty = Number(item.quantity) || 1;
    return sum + price * qty;
  }, 0);
}
